import { render, staticRenderFns } from "./ReportsUnavailable.vue?vue&type=template&id=4f65c8b9&scoped=true&"
var script = {}
import style0 from "./ReportsUnavailable.vue?vue&type=style&index=0&id=4f65c8b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65c8b9",
  null
  
)

export default component.exports